/**
 * The key we'll be saving our state within local storage.
 */
export const ROOT_STATE_STORAGE_KEY = 'root';
